
import { Component, Prop, Vue } from "vue-property-decorator";
import { TEmployeeSummary } from "@/models/employees";
import CompliancePremiumIcon from "@/assets/images/icons/compliance-premium.svg";
import DocumentVerifiedWarningIcon from "@/assets/images/icons/document-verified-warning.svg";
import { SMUser } from "@/store";

const ICONS = {
  close: "close",
};

@Component({})
export default class EmployeeSummaryDetails extends Vue {
  @Prop({ type: Object, required: true }) readonly employeeSummary!: TEmployeeSummary;

  icons = ICONS;

  get isPremium() {
    return SMUser.isPremiumSubscription;
  }

  get packageIcon() {
    return this.isPremium ? CompliancePremiumIcon : DocumentVerifiedWarningIcon;
  }

  get title() {
    if (this.isPremium) return this.$t("message.premium.title");

    return this.$t("message.basic.title");
  }

  get subtitle() {
    if (this.isPremium) return this.$t("message.premium.subtitle");

    return this.$t("message.basic.subtitle");
  }
}
